export const Header = () => {
  return (
    <div className="w-full sticky-header py-2 font-light text-xs leading-tight text-white bg-gradient-to-r from-red-950 via-red-900 to-black z-10">
      <div className="container">
        <div className="marquee-wrapper overflow-hidden">
          <div className="animate-marquee-wrapper flex">
            <div className="animate-marquee whitespace-nowrap animate-marquee-1">
              INDONESIA ULTRA 24 — 24 Hours Non-Stop at the Stadium Ring of Indomilk Arena, Targeting MURI Record as First Ultra Stadium Event in Indonesia.
            </div>
            <div className="animate-marquee whitespace-nowrap animate-marquee-2 ml-96">
              Every Lap Tells A Story — Indonesia's Premier 24-Hour Ultra Running Event on a National Scale (Towards International).
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
